module.exports = __webpack_public_path__ + "static/media/exam.b96b8a09.jpg";